import { render, staticRenderFns } from "./ServiceOrder.vue?vue&type=template&id=5edfba9a&scoped=true&"
import script from "./ServiceOrder.vue?vue&type=script&lang=js&"
export * from "./ServiceOrder.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOrder.vue?vue&type=style&index=0&id=5edfba9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edfba9a",
  null
  
)

export default component.exports